import request from '@/utils/request'

// 获取投放组列表
export function getReleaseGroupList(params = {}) {
  return request({
    url: '/ocean_release_report/release_group',
    method: 'get',
    params
  })
}

// 添加投放组
export function addReleaseGroup(data = {}) {
  return request({
    url: '/ocean_release_report/release_group',
    method: 'post',
    data
  })
}

// 更新投放组
export function updateReleaseGroup(data = {}) {
  return request({
    url: `/ocean_release_report/release_group/${data.id}`,
    method: 'PUT',
    data
  })
}

// 获取小程序列表
export function getAPPList(params = {}) {
  return request({
    url: '/ocean_release_report/mini_program',
    method: 'get',
    params
  })
}
// 更新小程序列表
export function updateAPP(data = {}) {
  return request({
    url: `ocean_release_report/mini_program/${data.id}`,
    method: 'PUT',
    data
  })
}
// 添加小程序
export function addAPP(data = {}) {
  return request({
    url: '/ocean_release_report/mini_program',
    method: 'post',
    data
  })
}

// 添加小程序自动绑定
export function syncAccount() {
  return request({
    url: '/ocean_release_report/sync_account',
    method: 'post'
  })
}

// 获取投放组投手列表
export function getListOfPitchersInTheLaunchGroup(params = {}) {
  return request({
    url: `/ocean_release_report/release_group_user`,
    method: 'get',
    params
  })
}

// 添加投放组投手
export function addOfPitchersInTheLaunchGroup(data = {}) {
  return request({
    url: `/ocean_release_report/release_group_user_add`,
    method: 'post',
    data
  })
}

// 删除投放组投手
export function deleteOfPitchersInTheLaunchGroup(data = {}) {
  return request({
    url: `/ocean_release_report/release_group_user_del`,
    method: 'DELETE',
    data
  })
}

// 投放位置列表
export function dropLocationList(params = {}) {
  return request({
    url: `/ocean_release_report/positions`,
    method: 'get',
    params
  })
}

export function miniProgramAccount(params = {}) {
  return request({
    url: '/ocean_release_report/mini_program_account',
    method: 'get',
    params
  })
}

// 获取绑定关系列表
export function getBindingRelationList(params = {}) {
  return request({
    url: `/ocean_release_report/bind_wechat`,
    method: 'get',
    params
  })
}

// 添加投放关系
export function addReleaseRelationship(data = {}) {
  return request({
    url: `/ocean_release_report/bind_wechat`,
    method: 'post',
    data
  })
}

// 修改投放关系
export function modifyReleaseRelationship(id, data = {}) {
  return request({
    url: `/ocean_release_report/bind_wechat/${id}`,
    method: 'put',
    data
  })
}

// 删除投放关系
export function deleteReleaseRelationship(id) {
  return request({
    url: `/ocean_release_report/bind_wechat/${id}`,
    method: 'DELETE'
  })
}

// 获取报表列表
export function getReportList(params = {}) {
  return request({
    url: `/ocean_release_report/bind_wechat_report`,
    method: 'get',
    params
  })
}

// 导出报表
export function exportReport(data = {}) {
  return request({
    url: `/ocean_release_report/export_bind_data`,
    method: 'post',
    data
  })
}
// 修改消耗
export function modifyConsumption(data = {}) {
  return request({
    url: `/ocean_release_report/edit_consume`,
    method: 'PUT',
    data
  })
}

// 修改RIO标准
export function modifyStandard(data = {}) {
  return request({
    url: `/ocean_release_report/edit_roi_standard`,
    method: 'PUT',
    data
  })
}
// 获取总计报表列表
export function getTotalReportList(params = {}) {
  return request({
    url: `/ocean_release_report/bind_wechat_total_report`,
    method: 'get',
    params
  })
}

// 导出总计报表
export function exportTotalReport(data = {}) {
  return request({
    url: `/ocean_release_report/export_bind_total_data`,
    method: 'POST',
    data
  })
}
// 导出小时报表
export function exportHourReport(data = {}) {
  return request({
    url: `/ocean_release_report/export_bind_hour_data`,
    method: 'POST',
    data
  })
}

export function launchTeamLeader(params = {}) {
  return request({
    url: `/ocean_release_report/release_group_leader`,
    method: 'get',
    params
  })
}

// 删除投放组
export function deleteMy(id) {
  return request({
    url: `/ocean_release_report/release_group/${id}`,
    method: 'delete'
  })
}// 删除小程序
export function deleteApp(id) {
  return request({
    url: `/ocean_release_report/mini_program/${id}`,
    method: 'delete'
  })
}// 删除绑定
export function delMiniAct(params = {}) {
  return request({
    url: `ocean_release_report/mini_program_account_del`,
    method: 'delete',
    params
  })
}

// 分组导出
export function bindwechatreportnew(params = {}) {
  return request({
    url: `/ocean_release_report/bind_wechat_report_new`,
    method: 'get',
    params
  })
}

// 巨量广告主列表
export function getAccountList(params = {}) {
  return request({
    url: `/ocean_release_report/account_list`,
    method: 'get',
    params
  })
}
// 巨量广告主列表
export function miniGroupActAdd(data = {}) {
  return request({
    url: `/ocean_release_report/mini_program_account_add`,
    method: 'post',
    data
  })
}
// 小时报表列表
export function hourReportList(params = {}) {
  return request({
    url: `/ocean_release_report/bind_wechat_hour_report`,
    method: 'get',
    params
  })
}
// 投手列表
export function departmentlist(params = {}) {
  return request({
    url: '/iaaMaterialReport/pitcher/index',
    method: 'get',
    params
  })
}
// 部门管理
export function iaaMaterialReportdepartmentlist(params = {}) {
  return request({
    url: '/iaaMaterialReport/department/index',
    method: 'get',
    params
  })
}
// 部门管理创建
export function iaaMaterialReportcreate(data = {}) {
  return request({
    url: '/iaaMaterialReport/department/create',
    method: 'post',
    data
  })
}
// 部门管理修改
export function iaaMaterialReportupdate(data = {}) {
  return request({
    url: '/iaaMaterialReport/department/update',
    method: 'post',
    data
  })
}

// 列表
export function iaapitcherindex(params = {}) {
  return request({
    url: '/iaaMaterialReport/pitcher/index',
    method: 'get',
    params
  })
}
// 创建
export function iaapitcherindexcreate(data = {}) {
  return request({
    url: '/iaaMaterialReport/pitcher/create',
    method: 'post',
    data
  })
}
// 删除
export function iaapitcherindexdestroy(data = {}) {
  return request({
    url: '/iaaMaterialReport/pitcher/destroy',
    method: 'post',
    data
  })
}
// 删除
export function iaadepartmentdestroy(data = {}) {
  return request({
    url: '/iaaMaterialReport/department/destroy',
    method: 'post',
    data
  })
}
// 列表
export function bindRelationindex(params = {}) {
  return request({
    url: '/iaaMaterialReport/bindRelation/index',
    method: 'get',
    params
  })
}
// 检查是否绑定
export function bindRelationcheck(data = {}) {
  return request({
    url: '/iaaMaterialReport/bindRelation/checkDuplicate',
    method: 'post',
    data
  })
}
// 创建
export function bindRelationcreate(data = {}) {
  return request({
    url: '/iaaMaterialReport/bindRelation/create',
    method: 'post',
    data
  })
}
// 修改
export function bindRelationupdate(data = {}) {
  return request({
    url: '/iaaMaterialReport/bindRelation/update',
    method: 'post',
    data
  })
}
// 删除
export function bindRelationdestroy(data = {}) {
  return request({
    url: '/iaaMaterialReport/bindRelation/destroy',
    method: 'post',
    data
  })
}
// IAA 回收
export function reportrecyclingList(data = {}) {
  return request({
    // url: '/iaaMaterialReport/report/recyclingList',
    url: '/iaaMaterialReport/report/recyclingListRds',
    method: 'post',
    data
  })
}
// 投手数据
export function reportpitcherList(params = {}) {
  return request({
    url: '/iaaMaterialReport/report/pitcherListRds',
    method: 'get',
    params
  })
}
// 投手收益排行
export function reportpitcherEarningsRank(params = {}) {
  return request({
    url: '/iaaMaterialReport/report/pitcherEarningsRank',
    method: 'get',
    params
  })
}
// 大看板
export function reportbigDataDashboard(params = {}) {
  return request({
    url: '/iaaMaterialReport/report/bigDataDashboard',
    method: 'get',
    params
  })
}
// 数据报表（仅消耗）
export function reportcostList(params = {}) {
  return request({
    url: '/iaaMaterialReport/report/costList',
    method: 'get',
    params
  })
}
// 投手收益排行详情
export function pitcherdetaillist(params = {}) {
  return request({
    url: '/iaaMaterialReport/report/pitcherDetail',
    method: 'get',
    params
  })
}
// 一键导入巨量广告
export function exportAdvertiserList(data = {}) {
  return request({
    url: '/iaaMaterialReport/bindRelation/exportAdvertiserList',
    method: 'post',
    data
  })
}

// ========== Native 端接口 ==========
// 列表
export function bindRelationindexNative(params = {}) {
  return request({
    url: '/iaaMaterialReportNative/bindRelation/index',
    method: 'get',
    params
  })
}
// 创建
export function bindRelationcreateNative(data = {}) {
  return request({
    url: '/iaaMaterialReportNative/bindRelation/create',
    method: 'post',
    data
  })
}
// 修改
export function bindRelationupdateNative(data = {}) {
  return request({
    url: '/iaaMaterialReportNative/bindRelation/update',
    method: 'post',
    data
  })
}
// 删除
export function bindRelationdestroyNative(data = {}) {
  return request({
    url: '/iaaMaterialReportNative/bindRelation/destroy',
    method: 'post',
    data
  })
}
// IAA 回收
export function reportrecyclingListNative(params = {}) {
  return request({
    url: '/iaaMaterialReportNative/report/recyclingList',
    method: 'get',
    params
  })
}
// 投手数据
export function reportpitcherListNative(params = {}) {
  return request({
    url: '/iaaMaterialReportNative/report/pitcherList',
    method: 'get',
    params
  })
}
// 投手收益排行
export function reportpitcherEarningsRankNative(params = {}) {
  return request({
    url: '/iaaMaterialReportNative/report/pitcherEarningsRank',
    method: 'get',
    params
  })
}
// 大看板
export function reportbigDataDashboardNative(params = {}) {
  return request({
    url: '/iaaMaterialReportNative/report/bigDataDashboard',
    method: 'get',
    params
  })
}
// 数据报表（仅消耗）
export function reportcostListNative(params = {}) {
  return request({
    url: '/iaaMaterialReportNative/report/costList',
    method: 'get',
    params
  })
}
// 投手收益排行详情
export function pitcherdetaillistNative(params = {}) {
  return request({
    url: '/iaaMaterialReportNative/report/pitcherDetail',
    method: 'get',
    params
  })
}
// 投手列表
export function iaapitcherindexNative(params = {}) {
  return request({
    url: '/iaaMaterialReportNative/pitcher/index',
    method: 'get',
    params
  })
}
// 部门管理列表
export function iaaMaterialReportdepartmentlistNative(params = {}) {
  return request({
    url: '/iaaMaterialReportNative/department/index',
    method: 'get',
    params
  })
}
// 一键导入巨量广告 Native
export function exportAdvertiserListNative(data = {}) {
  return request({
    url: '/iaaMaterialReportNative/bindRelation/exportAdvertiserList',
    method: 'post',
    data
  })
}
// 账户报表列表
export function accountReportList(params = {}) {
  return request({
    url: '/iaaMaterialReport/report/accountReportList',
    method: 'get',
    params
  })
}
// 项目报表列表
export function projectReportList(params = {}) {
  return request({
    url: '/iaaMaterialReport/report/projectReportList',
    method: 'get',
    params
  })
}
// 推广单元报表列表
export function promotionReportList(params = {}) {
  return request({
    url: '/iaaMaterialReport/report/promotionReportList',
    method: 'get',
    params
  })
}
